import { MarkedDates } from 'react-native-calendars/src/types';
import { StateCreator } from 'zustand';

export interface SessionZustandSlice {
    token: string | null;
    favouriteEdition: string;
    selectedDate: string | null;

    updateSessionToken: (token: string | null) => void;
    updateSessionFavouriteEdition: (edition: string) => void;
    updateSelectedDate: (newSelectedDate: string | null) => void;

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createSessionZustandSlice: StateCreator<SessionZustandSlice> = (set, get) => ({
    token: null,
    favouriteEdition: 'DLZ',
    selectedDate: null,

    updateSessionToken: (token: string | null) => {
        const currentToken = get().token;

        if (currentToken !== token) {
            set(() => ({ token }));
        } else {
            //console.log("Session token unchanged.");
        }
    },
    updateSessionFavouriteEdition: (favouriteEdition: string) => {
        //console.log("Store - SessionZustandSlice - favouriteEdition updated", favouriteEdition),
        set(() => ({ favouriteEdition: favouriteEdition }))
    },
    updateSelectedDate: (newSelectedDate: string | null) => {
        //console.log("Store - SessionZustandSlice - favouriteDate updated", favouriteDate),
        set(() => ({ selectedDate: newSelectedDate }))
    },

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});